import React from "react";
import { tabs } from "./helper";
import { SideNavBar, SideNavBarV2 } from "../../components";

export const PartDetailsMenu = ({ value = "ROUTING", setValue = () => {} }) => {
  const props = { tabs, value, setValue };
  return <SideNavBarV2 {...props} />;
};

export default PartDetailsMenu;
